import { ApiProperty } from "@nestjs/swagger";


export class EmployeeFreebiesAssignRequest {
    @ApiProperty()
    employeeFreebiesId: number;
    @ApiProperty()
    employeeCode: string;
    @ApiProperty()
    freebieCode: string;
    @ApiProperty()
    username: string;
    @ApiProperty()
    freebieCount: number;
    @ApiProperty()
    year: number;
    @ApiProperty()
    month: number;
    @ApiProperty()
    maxConsumptionPerDay: number;

    @ApiProperty()
    employeeId?: number; // not required from the request object
    @ApiProperty()
    freebieId: number; // not required from the request object

}